import { get, post } from '@/utils/request'

/**
 * 获取通知列表
 * @param {Object} params 查询参数
 * @returns {Promise} 请求响应
 */
export function getNotifications(params) {
  return get('/notifications', params)
}

/**
 * 获取未读通知数量
 * @returns {Promise} 请求响应
 */
export function getUnreadCount() {
  return get('/notifications/unread/count')
}

/**
 * 标记通知为已读
 * @param {String|Array} ids 通知ID或ID数组
 * @returns {Promise} 请求响应
 */
export function markAsRead(ids) {
  return post('/notifications/read', { ids })
}

/**
 * 标记所有通知为已读
 * @returns {Promise} 请求响应
 */
export function markAllAsRead() {
  return post('/notifications/read/all')
}

/**
 * 删除通知
 * @param {String|Array} ids 通知ID或ID数组
 * @returns {Promise} 请求响应
 */
export function deleteNotifications(ids) {
  return post('/notifications/delete', { ids })
} 